import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Support() {
  return <Box><Typography variant="h4">Support</Typography></Box>;
}
